import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Field } from "@/components/yarn/Field";
import { useAuth } from "@/context/AuthContext";
import { api, errorText } from "@/lib/api";

export function LoginForm() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { username, password });
      signIn(data.token, data.user);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      if (detail?.code === "not_verified") {
        toast(detail.msg);
        navigate(`/verify?u=${encodeURIComponent(detail.username)}&hint=${encodeURIComponent(detail.email_hint)}`);
      } else {
        toast.error(errorText(err));
      }
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="login-form">
      <Field label="Username or email" id="login-username" autoComplete="username" required value={username}
        onChange={(e) => setUsername(e.target.value)} data-testid="login-username-input" />
      <Field label="Password" id="login-password" type="password" autoComplete="current-password" required value={password}
        onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
      <button type="submit" className="btn-yarn w-full h-14 text-lg" disabled={busy} data-testid="login-submit-button">
        {busy ? "Untangling..." : "Log in"}
      </button>
    </form>
  );
}
